import React, { useRef } from "react";

import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import * as Styles from "./styles/GradeEngineList";

import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import type { ModelGradeMotorizationType, ModelGradeType } from "../../../../../../common-deprecated/types/CommonTypes";
import EngineBlock from "./GradeEngineBlock";
import { BnbLabel } from "../../../utils/labels";
import { EngineListControls } from "./EngineListControls";
import { trackSelectEngine } from "../../../utils/tracking";
import { NavStep } from "../../../../shared-logic/utils/Navigation";

type GradeEnginesOverviewPropsType = {
    grade: ModelGradeType;
    engines: ModelGradeMotorizationType[];
    isSelected: boolean;
    setSelected: (gradeId: string) => void;
};

const GradeEnginesOverview = ({
    engines,
    grade,
    setSelected,
    isSelected,
}: GradeEnginesOverviewPropsType): JSX.Element | null => {
    const engineListRef = useRef<HTMLDivElement>(null);

    return (
        <Styles.EnginesWrapper aria-expanded={isSelected}>
            <Styles.EngineButton
                type="button"
                aria-pressed={isSelected}
                aria-controls="engine-list"
                tabIndex={0}
                onClick={() => {
                    setSelected(isSelected ? "" : grade.id);
                    if (!isSelected) {
                        trackSelectEngine(NavStep.ModelEngine, grade.name);
                    }
                }}
            >
                <Text.Button>
                    <BnbLabel label="selectEngine" />
                </Text.Button>
                <IconWrapper iconColor={isSelected ? "primaryBlack" : "primaryWhite"} aria-hidden="true">
                    <Icon variant={isSelected ? "close" : "chevronDown"} />
                </IconWrapper>
            </Styles.EngineButton>
            <Styles.EngineList id="engine-list" aria-expanded={isSelected} tabIndex={-1}>
                <Styles.EngineListHeader>
                    <BnbLabel label="options" params={{ value: engines.length }} />
                    <EngineListControls listRef={engineListRef} grade={grade} />
                </Styles.EngineListHeader>
                <Styles.EngineListContent ref={engineListRef}>
                    {engines.map((engine, index) => (
                        <EngineBlock
                            motorization={engine}
                            grade={grade}
                            key={`${engine.engine.id}-${engine.transmission.id}-${engine.wheeldrive.id}`}
                            index={index + 1}
                        />
                    ))}
                </Styles.EngineListContent>
            </Styles.EngineList>
        </Styles.EnginesWrapper>
    );
};

export default GradeEnginesOverview;
